module.exports = __webpack_public_path__ + "static/media/hearts_6.402f9a02.png";